import { EventProxy } from './eventProxy';
export var EventEmitTypes;
(function (EventEmitTypes) {
    EventEmitTypes["MANAGE_RESOURCE"] = "manage_resource";
    EventEmitTypes["MANAGE_HOT_AREA"] = "manage_hot_area";
    EventEmitTypes["MANAGE_HISTORY"] = "manage_history";
    EventEmitTypes["PREVIEW"] = "preview";
    EventEmitTypes["REFRESH_SIMULATOR"] = "refresh_simulator";
    EventEmitTypes["RELOAD_MATERIALS"] = "reload_materials";
    EventEmitTypes["SCROLL_TO_COMPONENT"] = "scroll_to_component";
    EventEmitTypes["JUMP_PROP_EDIT_TAB"] = "jump_prop_edit_tab";
    EventEmitTypes["COMPONENT_INTERSECTING_CHANGE"] = "component_intersecting_change";
    EventEmitTypes["HOT_AREA_INTERSECTING_CHANGE"] = "hot_area_intersecting_change";
    EventEmitTypes["CHANGE_PROP_EDIT_TAB"] = "change_prop_edit_tab";
    EventEmitTypes["SCROLL_SIMULATOR"] = "scroll_simulator";
    EventEmitTypes["SET_RULER_DISTANCE"] = "set_ruler_distance";
    EventEmitTypes["CAPTURE_COMPONENT_MASK_CLICK_CALLBACK"] = "capture_component_mask_click_handler";
    EventEmitTypes["ORIENTATION_CHANGE"] = "simulator_orientation_change";
})(EventEmitTypes || (EventEmitTypes = {}));
export var SimulateEventTypes;
(function (SimulateEventTypes) {
    SimulateEventTypes["ORIENTATION_CHANGE"] = "orientationchange";
})(SimulateEventTypes || (SimulateEventTypes = {}));
export var events = new EventProxy();
export function registerCustomEventTypes(CustomEventTypes) {
    Object.assign(EventEmitTypes, CustomEventTypes);
}
//# sourceMappingURL=eventEmiter.js.map